import { FaWhatsapp } from "react-icons/fa";
import { Phone, MapPin, Clock } from "lucide-react";

const PHONE = "(67) 99650-8622";
const WHATSAPP_URL = "https://wa.me/5567996508622?text=Ol%C3%A1%2C%20preciso%20de%20um%20guincho!";
const TEL_URL = "tel:+5567996508622";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_372d2d44-3a54-4a7a-9e26-4e2b8f432aad/artifacts/baaqn7xs_ChatGPT%20Image%2016%20de%20abr.%20de%202026%2C%2006_16_22.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#27272A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <img
              src={LOGO_URL}
              alt="Huck Guincho 24HS"
              className="h-14 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Guincho 24h em Navirai e Regiao. Atendimento rapido, seguro e
              profissional para qualquer tipo de veiculo.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3
              className="text-lg font-bold uppercase tracking-tight text-[#FFD700] mb-4"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              Contato
            </h3>
            <div className="space-y-3">
              <a
                href={TEL_URL}
                data-testid="footer-phone"
                className="flex items-center gap-3 text-gray-300 hover:text-[#FFD700] transition-colors"
              >
                <Phone className="w-4 h-4 text-[#FFD700]" />
                <span className="text-sm font-medium">{PHONE}</span>
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="flex items-center gap-3 text-gray-300 hover:text-[#25D366] transition-colors"
              >
                <FaWhatsapp className="w-4 h-4 text-[#25D366]" />
                <span className="text-sm font-medium">WhatsApp</span>
              </a>
              <div className="flex items-start gap-3 text-gray-300">
                <MapPin className="w-4 h-4 text-[#FFD700] mt-0.5 flex-shrink-0" />
                <span className="text-sm">Rua Peru, 270 - Navirai/MS</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3
              className="text-lg font-bold uppercase tracking-tight text-[#FFD700] mb-4"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              Horario
            </h3>
            <div className="flex items-center gap-3 text-gray-300">
              <Clock className="w-4 h-4 text-[#FFD700]" />
              <span className="text-sm font-medium">
                24 horas - Todos os dias
              </span>
            </div>
            <div className="mt-4 inline-block bg-[#FFD700] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest">
              Sempre disponivel
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#27272A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-center text-xs text-gray-500">
            Huck Guincho 24HS - Guincho 24h em Navirai e Regiao | Todos os
            direitos reservados
          </p>
        </div>
      </div>
    </footer>
  );
}
